import keyMirror from 'keymirror'

const ConversationTypes = keyMirror({
  EMAIL: null,
  CHAT: null,
  PRIVATE_NOTE: null,
  PRIVATE_PROMPT: null,
})

export default ConversationTypes



// WEBPACK FOOTER //
// ./src/scripts/utils/ConversationTypes.js